import React, { useEffect, useState } from 'react';

// import SmallTile from './SmallTile';
import BigTile from './BigTile';

import { dbDateToTimestamp } from '../../utils/helpers';

const AgendaCard = ({ movie, id, activeFilterDate, filterTags, animationDelay, currentConfig, fromTime }) => {
  const [releaseDate, setReleaseDate] = useState('');

  useEffect(() => {
    if ('dates' in movie && movie.dates.release) {
      const date = dbDateToTimestamp(movie.dates.release + '0000');
      setReleaseDate(date);
    }
  }, []);

  const handleTagClick = (value, onlyActivate) => {
    filterTags(value, onlyActivate);
  };

  if (currentConfig.agenda_tile_type === 'small' || (currentConfig.agenda_tile_type === 'both' && fromTime)) {
    return (
      <SmallTile movie={movie} id={id} activeFilterDate={activeFilterDate} animationDelay={animationDelay} currentConfig={currentConfig} releaseDate={releaseDate} handleTagClick={handleTagClick} />
    );
  }

  if (currentConfig.agenda_tile_type === 'big' || (currentConfig.agenda_tile_type === 'both' && !fromTime)) {
    return (
      <BigTile movie={movie} id={id} activeFilterDate={activeFilterDate} animationDelay={animationDelay} currentConfig={currentConfig} releaseDate={releaseDate} handleTagClick={handleTagClick} />
    );
  }

  return <></>;
};

export default AgendaCard;
